module.exports = __webpack_public_path__ + "static/media/Bayswater Ave Burlingame, CA3.6a8fc918.jpg";